/**************************************************
 * Nombre:       Home_Perspectiva_Escuelas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import foto from '../../../Recursos/foto_hombre.png'
import foto_chica from '../../../Recursos/foto_chica.png'
import Tarjeta_Estudia from "../../Tarjetas/Tarjeta_Estudia";
import Zoom from 'react-reveal/Zoom';

const Home_Perspectiva_Escuelas = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{backgroundColor: '#28517130', mt: 16}}

        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, mt: -16, mb: 8}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={4}
                    >

                        {items.map((item, index) => (
                            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                <Zoom>
                                    <Tarjeta_Estudia item={item}/>
                                </Zoom>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Perspectiva_Escuelas

const items = [
    {
        nombre: 'Estudia en CESSA',
        descripcion: 'Inicia tu técnico con proyección universitaria y asegura tu éxito laboral. Fórmate con calidad, flexibilidad y programas diseñados para el mercado actual',
        img: foto,
        color: "#047C99"
    },
    {
        nombre: 'ESCUELAS DE APRENDIZAJE',
        descripcion: 'Formamos ciudadanos comprometidos con el progreso regional y el tejido social. Vive una experiencia académica conectada con el desarrollo de Nariño',
        img: foto_chica,
        color: "#285171"
    },
]